import * as React from 'react';
import { IStackTokens, Stack, FocusZone } from '@fluentui/react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { FieldColumnOptions } from './FieldColumnOptions';
import { FC, useState } from 'react';
import { AnalyticsField, FieldSet } from './AnalyticsModel';

interface Props {
  fieldsInput: FieldSet;
  updateFieldsInParent: Function;
  allAVFields: AnalyticsField[];
}

const FieldSelectionTab: FC<Props> = (props) => {
  const [fieldValues, setFieldValues] = useState<string[]>(props.fieldsInput?.fields || []);

  const stackTokens: IStackTokens = { childrenGap: 15 };

  const OnFieldsAdded = (data: any) => {
    //API
    setFieldValues(data.selectedColumn);

    const fieldsInput: FieldSet = {
      fieldType: 1,
      fields: data.selectedColumn,
    };

    props.updateFieldsInParent(fieldsInput);
  };
  return (
    <>
      <div className='ms-Grid'>
        <div>
          {/*this.state.showSpinner && (
                        <Spinner
                            size={SpinnerSize.large}
                            label={UATConstants.PlaceholdersAndTitles.Loading}
                            ariaLive="assertive"
                            className="loading-panel-full"
                        />
                    )*/}
        </div>
        <Stack tokens={stackTokens} className='marginLeft8px'>
          <div>
            <FocusZone>
              <div className='paddingRight30px'>
                <div className='height15'></div>
                <Stack tokens={stackTokens}>
                  <div className='ms-Grid-row'>
                    <div className='ms-Grid-col ms-lg12'>
                      <div className='customFilterContainer'>
                        <FieldColumnOptions
                          avFields={props.allAVFields}
                          onAddColumnOptions={OnFieldsAdded}
                          fieldValues={fieldValues}
                        />
                      </div>
                    </div>
                  </div>
                </Stack>
              </div>
            </FocusZone>
          </div>
          <div className='height30'></div>
        </Stack>
      </div>
    </>
  );
};

export default FieldSelectionTab;
